/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import VuexEasyFirestore from "vuex-easy-firestore";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import firebase from "firebase/app";
import moduleAuth from "./auth/moduleAuth.js";
import moduleOrders from "./orders/moduleOrders.js";

const easyFirestore = VuexEasyFirestore([moduleOrders], {
	logging: true,
	FirebaseDependency: firebase
});

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth: moduleAuth
	},
	plugins: [easyFirestore],
	strict: process.env.NODE_ENV !== "production"
});
